export const lifetimeConverts = [
  {
    name: "Jane Davies",
    lifespan: "1834\u20131898",
    baptized: "April 1850",
    age: 16,
    relationship: "3x great-grandmother (mother \u2192 mother \u2192 mother \u2192 mother \u2192 mother)",
    pid: "KWJZ-KF8",
    endowment: "7 September 1861",
  },
  {
    name: "Joannah Eliza Jennings",
    lifespan: "1866\u20131934",
    baptized: "2 August 1883",
    age: 17,
    relationship: "2x great-grandmother (mother \u2192 father \u2192 father \u2192 mother)",
    pid: "KWZP-LPS",
    endowment: "16 October 1884 (Endowment House)",
  },
  {
    name: "William John Lewis",
    lifespan: "1832\u20131900",
    baptized: "4 July 1849",
    age: 17,
    relationship: "3x great-grandfather (mother \u2192 mother \u2192 mother \u2192 mother \u2192 father)",
    pid: "KWZL-DQS",
    endowment: "7 September 1861 (Endowment House)",
  },
  {
    name: "David John",
    lifespan: "1833\u20131908",
    baptized: "6 February 1856",
    age: 23,
    relationship: "3x great-grandfather (mother \u2192 father \u2192 mother \u2192 mother \u2192 father)",
    pid: "KWJZ-HGK",
    endowment: "5 December 1862 (Endowment House)",
  },
  {
    name: "Truman Leonard Jr.",
    lifespan: "1820\u20131897",
    baptized: "25 March 1843",
    age: 23,
    relationship: "3x great-grandfather (mother \u2192 mother \u2192 father \u2192 mother \u2192 father)",
    pid: "KWJ6-WR5",
    endowment: "25 December 1845",
  },
  {
    name: "Celia Emeline Knox Riggs",
    lifespan: "1849\u20131927",
    baptized: "6 July 1875",
    age: 26,
    relationship: "2x great-grandmother (father \u2192 mother \u2192 mother \u2192 mother)",
    pid: "KWZC-H7Z",
    endowment: "9 December 1865 (Endowment House)",
  },
  {
    name: "William Bannister Poppleton",
    lifespan: "1823\u20131883",
    baptized: "12 February 1849",
    age: 26,
    relationship: "3x great-grandfather (father \u2192 mother \u2192 mother \u2192 father \u2192 father)",
    pid: "KWJD-V8M",
    endowment: "5 January 1861 (Endowment House)",
  },
  {
    name: "Sarah Stennett",
    lifespan: "1823\u20131855",
    baptized: "14 February 1849",
    age: 26,
    relationship: "3x great-grandmother (father \u2192 mother \u2192 mother \u2192 father \u2192 mother)",
    pid: "LLQF-6XR",
    endowment: "8 December 1882 (St. George Utah Temple)",
  },
  {
    name: "Mary Wride",
    lifespan: "1831\u20131905",
    baptized: "20 March 1857",
    age: 26,
    relationship: "3x great-grandmother (mother \u2192 father \u2192 mother \u2192 mother \u2192 mother)",
    pid: "KWJZ-HGL",
    endowment: "5 December 1862 (Endowment House)",
  },
  {
    name: "Hans Jorgen Johnson",
    lifespan: "1826\u20131904",
    baptized: "15 May 1852",
    age: 26,
    relationship: "4x great-grandfather (mother \u2192 mother \u2192 father \u2192 father \u2192 mother \u2192 father)",
    pid: "KWJ8-QSM",
    endowment: "26 March 1857 (Endowment House)",
  },
  {
    name: "Peter Maughan",
    lifespan: "1811\u20131871",
    baptized: "19 November 1838",
    age: 27,
    relationship: "3x great-grandfather (father \u2192 mother \u2192 father \u2192 father \u2192 father)",
    pid: "KWJ6-XQC",
    endowment: "2 February 1846 (Nauvoo (Historical))",
  },
  {
    name: "Hannah Rebecca Spiller",
    lifespan: "1820\u20131901",
    baptized: "1 January 1847",
    age: 27,
    relationship: "4x great-grandmother (mother \u2192 father \u2192 father \u2192 mother \u2192 mother \u2192 mother)",
    pid: "KWVW-QKM",
    endowment: "14 June 1869 (Endowment House)",
  },
  {
    name: "Inger Christine Nielsdatter",
    lifespan: "1826\u20131913",
    baptized: "1 June 1853",
    age: 27,
    relationship: "4x great-grandmother (mother \u2192 mother \u2192 father \u2192 father \u2192 mother \u2192 mother)",
    pid: "KWJ8-Q9B",
    endowment: "26 March 1857 (Endowment House)",
  },
  {
    name: "Hans Christian Hansen",
    lifespan: "1848\u20131924",
    baptized: "3 September 1876",
    age: 28,
    relationship: "3x great-grandfather (father \u2192 father \u2192 mother \u2192 mother \u2192 father)",
    pid: "KVP1-PVW",
    endowment: "6 September 1875 (Endowment House)",
  },
  {
    name: "Caroline Elizabeth Caldwell",
    lifespan: "1826\u20131891",
    baptized: "29 July 1855",
    age: 29,
    relationship: "3x great-grandmother (father \u2192 father \u2192 father \u2192 father \u2192 mother)",
    pid: "KWVG-QB8",
    endowment: "24 August 1861 (Endowment House)",
  },
  {
    name: "Jean Wilson",
    lifespan: "1815\u20131889",
    baptized: "28 April 1844",
    age: 29,
    relationship: "3x great-grandmother (father \u2192 mother \u2192 father \u2192 mother \u2192 mother)",
    pid: "KWJ8-TL7",
    endowment: "26 May 1866 (Endowment House)",
  },
  {
    name: "Ann Redding",
    lifespan: "1819\u20131899",
    baptized: "June 1848",
    age: 29,
    relationship: "4x great-grandmother (mother \u2192 mother \u2192 mother \u2192 father \u2192 father \u2192 mother)",
    pid: "KWVS-RP2",
    endowment: "7 November 1865 (Endowment House)",
  },
  {
    name: "William Stennett Poppleton",
    lifespan: "1844\u20131923",
    baptized: "6 July 1875",
    age: 31,
    relationship: "2x great-grandfather (father \u2192 mother \u2192 mother \u2192 father)",
    pid: "KWZM-73M",
    endowment: "9 December 1865 (Endowment House)",
  },
  {
    name: "John McIntosh",
    lifespan: "1824\u20131859",
    baptized: "21 March 1857",
    age: 33,
    relationship: "3x great-grandfather (father \u2192 father \u2192 father \u2192 father \u2192 father)",
    pid: "KWVG-QBD",
    endowment: "20 September 1888",
  },
  {
    name: "Mathias Nelson",
    lifespan: "1829\u20131910",
    baptized: "23 March 1863",
    age: 34,
    relationship: "3x great-grandfather (father \u2192 father \u2192 father \u2192 mother \u2192 father)",
    pid: "K2HM-94M",
    endowment: "25 April 1870 (Endowment House)",
  },
  {
    name: "James Nibley",
    lifespan: "1810\u20131876",
    baptized: "28 April 1844",
    age: 34,
    relationship: "3x great-grandfather (father \u2192 mother \u2192 father \u2192 mother \u2192 father)",
    pid: "KWJ8-TLQ",
    endowment: "19 May 1866 (Endowment House)",
  },
  {
    name: "Calista Bass",
    lifespan: "1811\u20131863",
    baptized: "February 1845",
    age: 34,
    relationship: "4x great-grandmother (mother \u2192 mother \u2192 father \u2192 father \u2192 father \u2192 mother)",
    pid: "KWJ6-5QF",
    endowment: "1 March 1852 (Endowment House)",
  },
  {
    name: "Polly Victoria Barnett",
    lifespan: "1814\u20131892",
    baptized: "July 1849",
    age: 35,
    relationship: "4x great-grandmother (mother \u2192 father \u2192 father \u2192 mother \u2192 father \u2192 mother)",
    pid: "KWJT-BJQ",
    endowment: "25 April 1868 (Endowment House)",
  },
  {
    name: "John Shields",
    lifespan: "1805\u20131887",
    baptized: "4 July 1841",
    age: 36,
    relationship: "4x great-grandfather (father \u2192 father \u2192 mother \u2192 father \u2192 father \u2192 father)",
    pid: "KWJY-7ZJ",
    endowment: "11 June 1856 (Endowment House)",
  },
  {
    name: "Ira Allen",
    lifespan: "1814\u20131900",
    baptized: "30 March 1851",
    age: 37,
    relationship: "4x great-grandfather (mother \u2192 mother \u2192 father \u2192 father \u2192 father \u2192 father)",
    pid: "KWNF-SGD",
    endowment: "1 March 1852 (Endowment House)",
  },
  {
    name: "Soren Peter Jensen",
    lifespan: "1836\u20131905",
    baptized: "16 March 1875",
    age: 39,
    relationship: "3x great-grandfather (mother \u2192 father \u2192 father \u2192 father \u2192 father)",
    pid: "KWJ8-6YK",
    endowment: "8 July 1925 (Logan Utah Temple)",
  },
  {
    name: "Mary Ann Meadows",
    lifespan: "1835\u20131899",
    baptized: "1 August 1875",
    age: 40,
    relationship: "3x great-grandmother (mother \u2192 mother \u2192 father \u2192 mother \u2192 mother)",
    pid: "KWJX-5BT",
    endowment: "27 March 1857 (Endowment House)",
  },
  {
    name: "Bertha Persson",
    lifespan: "1811\u20131896",
    baptized: "11 August 1851",
    age: 40,
    relationship: "4x great-grandmother (father \u2192 father \u2192 father \u2192 mother \u2192 mother \u2192 mother)",
    pid: "KWJY-L67",
    endowment: "14 March 1871",
  },
  {
    name: "Kirsten Marie Christensdatter",
    lifespan: "1834\u20131896",
    baptized: "16 March 1875",
    age: 41,
    relationship: "3x great-grandmother (mother \u2192 father \u2192 father \u2192 father \u2192 mother)",
    pid: "KWJ8-6YJ",
    endowment: "23 October 1879 (Endowment House)",
  },
  {
    name: "Martha Scott",
    lifespan: "1801\u20131856",
    baptized: "September 1842",
    age: 41,
    relationship: "4x great-grandmother (father \u2192 father \u2192 mother \u2192 father \u2192 mother \u2192 mother)",
    pid: "KWJF-7R9",
    endowment: "17 February 1854",
  },
  {
    name: "Fanny Jane Perris",
    lifespan: "1842\u20131919",
    baptized: "17 August 1884",
    age: 42,
    relationship: "3x great-grandmother (mother \u2192 father \u2192 father \u2192 mother \u2192 mother)",
    pid: "K2H1-CHL",
    endowment: "4 October 1861 (Endowment House)",
  },
  {
    name: "Peter Gillespie",
    lifespan: "1796\u20131861",
    baptized: "27 July 1842",
    age: 46,
    relationship: "4x great-grandfather (father \u2192 father \u2192 mother \u2192 father \u2192 mother \u2192 father)",
    pid: "KWJ6-28X",
    endowment: "17 February 1854 (Endowment House)",
  },
  {
    name: "Ellen Scott Gillespie",
    lifespan: "1840\u20131890",
    baptized: "14 September 1889",
    age: 49,
    relationship: "3x great-grandmother (father \u2192 father \u2192 mother \u2192 father \u2192 mother)",
    pid: "KWN5-JTW",
    endowment: "6 September 1861 (Endowment House)",
  },
  {
    name: "David Williams",
    lifespan: "1827\u20131889",
    baptized: "8 January 1876",
    age: 49,
    relationship: "3x great-grandfather (mother \u2192 father \u2192 mother \u2192 father \u2192 father)",
    pid: "KJWX-4SN",
    endowment: "24 January 1878 (Endowment House)",
  },
  {
    name: "Mary Chalk",
    lifespan: "1792\u20131878",
    baptized: "26 June 1849",
    age: 57,
    relationship: "5x great-grandmother (mother \u2192 mother \u2192 mother \u2192 father \u2192 father \u2192 mother \u2192 mother)",
    pid: "KWVW-7FG",
    endowment: "31 October 1870 (Endowment House)",
  },
  {
    name: "James Pope Paskett",
    lifespan: "1817\u20131903",
    baptized: "19 September 1875",
    age: 58,
    relationship: "4x great-grandfather (mother \u2192 mother \u2192 mother \u2192 father \u2192 mother \u2192 father)",
    pid: "KWJW-3C2",
    endowment: "4 October 1875 (Endowment House)",
  },
  {
    name: "Nils Gronquist Smitt Jensson",
    lifespan: "1780\u20131833",
    baptized: "10 July 1850",
    age: 70,
    relationship: "5x great-grandfather (father \u2192 father \u2192 father \u2192 mother \u2192 mother \u2192 father \u2192 father)",
    pid: "L6VD-J5Q",
    endowment: "16 August 1862 (Endowment House)",
  },
]
